<template>
  <div>
    <Dialog
      :visible.sync="videoDialog1"
      :style="{ width: '100vmin', overflowY: 'auto' }"
      header="Videos"
      :modal="true"
      class="p-fluid"
    >
      <div style="padding-bottom: 21px;">
        <div style="font-size: 1.3rem;">
          <strong style="padding-left: 10px;">Title: </strong>
          {{ video.videoTitle }}
          <span v-if="video.length" style="float: right;">
            <strong style="padding-left: 10px;">Duration: </strong>
            {{ (video.length / 60).toFixed(2) }}mins
          </span>
          <div>
            <strong style="padding-left: 10px;">Description: </strong>
            {{ video.description }}
          </div>
        </div>
        <div v-if="video">
          <iframe
            width="100%"
            height="500px"
            :src="getEmbededURL(video.url)"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script>
export default {
  props: {
    video: {
      type: Object,
      required: true
    },
    videoDialog: {
      type: Boolean,
      required: false
    }
  },
  computed: {
    videoDialog1: {
      set(val) {
        if (!val) {
          this.$emit("close");
        }
      },
      get() {
        return this.videoDialog;
      }
    }
  },
  methods: {
    getEmbededURL(url) {
      if (url && url.length >= 8) {
        return `https://www.youtube.com/embed/${url.substr(8)}`;
      } else {
        return "";
      }
    }
  }
};
</script>

<style></style>
